<div
  class="cookie-banner"
  [class.show]="showBanner"
  role="dialog"
  aria-labelledby="cookie-banner-title"
  data-testid="cookie-banner"
>
  <div class="cookie-banner__container">
    <div class="cookie-banner__content">
      <!-- Banner Header -->
      <div class="cookie-banner__header">
        <h3 id="cookie-banner-title" class="cookie-banner__title">🍪 We value your privacy</h3>
      </div>

      <!-- Basic Banner View -->
      <div class="cookie-banner__body" *ngIf="!showDetails">
        <p class="cookie-banner__description">
          We use cookies to enhance your browsing experience, serve personalized content, and
          analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
        </p>

        <div class="cookie-banner__actions">
          <button
            type="button"
            class="btn btn--secondary"
            (click)="acceptNecessaryOnly()"
            aria-label="Accept only necessary cookies"
            data-testid="accept-necessary"
          >
            Necessary Only
          </button>

          <button
            type="button"
            class="btn btn--outline"
            (click)="toggleDetails()"
            aria-label="Customize cookie preferences"
            data-testid="customize-cookies"
          >
            Customize
          </button>

          <button
            type="button"
            class="btn btn--primary"
            (click)="acceptAll()"
            aria-label="Accept all cookies"
            data-testid="accept-all"
          >
            Accept All
          </button>
        </div>
      </div>

      <!-- Detailed Preferences View -->
      <div class="cookie-banner__details" *ngIf="showDetails">
        <p class="cookie-banner__description">
          Choose which cookies you'd like to accept. You can change these settings at any time.
        </p>

        <div class="cookie-preferences">
          <!-- Necessary Cookies -->
          <div class="cookie-category">
            <div class="cookie-category__header">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  [checked]="preferences.necessary"
                  disabled
                  aria-describedby="necessary-description"
                />
                <span class="checkbox-custom"></span>
                <span class="cookie-category__title">Necessary Cookies</span>
                <span class="cookie-category__badge">Always Active</span>
              </label>
            </div>
            <div class="cookie-category__content">
              <p id="necessary-description" class="cookie-category__description">
                {{ getCookieDescription('necessary') }}
              </p>
              <p class="cookie-category__examples">
                <strong>Examples:</strong> {{ getCookieExamples('necessary') }}
              </p>
            </div>
          </div>

          <!-- Analytics Cookies -->
          <div class="cookie-category">
            <div class="cookie-category__header">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  [(ngModel)]="preferences.analytics"
                  aria-describedby="analytics-description"
                />
                <span class="checkbox-custom"></span>
                <span class="cookie-category__title">Analytics Cookies</span>
              </label>
            </div>
            <div class="cookie-category__content">
              <p id="analytics-description" class="cookie-category__description">
                {{ getCookieDescription('analytics') }}
              </p>
              <p class="cookie-category__examples">
                <strong>Examples:</strong> {{ getCookieExamples('analytics') }}
              </p>
            </div>
          </div>

          <!-- Marketing Cookies -->
          <div class="cookie-category">
            <div class="cookie-category__header">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  [(ngModel)]="preferences.marketing"
                  aria-describedby="marketing-description"
                />
                <span class="checkbox-custom"></span>
                <span class="cookie-category__title">Marketing Cookies</span>
              </label>
            </div>
            <div class="cookie-category__content">
              <p id="marketing-description" class="cookie-category__description">
                {{ getCookieDescription('marketing') }}
              </p>
              <p class="cookie-category__examples">
                <strong>Examples:</strong> {{ getCookieExamples('marketing') }}
              </p>
            </div>
          </div>

          <!-- Functional Cookies -->
          <div class="cookie-category">
            <div class="cookie-category__header">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  [(ngModel)]="preferences.functional"
                  aria-describedby="functional-description"
                />
                <span class="checkbox-custom"></span>
                <span class="cookie-category__title">Functional Cookies</span>
              </label>
            </div>
            <div class="cookie-category__content">
              <p id="functional-description" class="cookie-category__description">
                {{ getCookieDescription('functional') }}
              </p>
              <p class="cookie-category__examples">
                <strong>Examples:</strong> {{ getCookieExamples('functional') }}
              </p>
            </div>
          </div>
        </div>

        <!-- Detailed Actions -->
        <div class="cookie-banner__actions">
          <button
            type="button"
            class="btn btn--outline"
            (click)="toggleDetails()"
            aria-label="Go back to simple view"
          >
            Back
          </button>

          <button
            type="button"
            class="btn btn--secondary"
            (click)="acceptNecessaryOnly()"
            aria-label="Accept only necessary cookies"
          >
            Necessary Only
          </button>

          <button
            type="button"
            class="btn btn--primary"
            (click)="savePreferences()"
            aria-label="Save selected preferences"
          >
            Save Preferences
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
